import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import { getTimeLeft } from '../../utils/time';
import { PairSpreadCalc2 } from './PairSpreadCalc2';
import './styles.css';
import { Typography } from '@mui/material';
import { IPairExtended } from '../PairSpreadItem/PairSpreadItem';
import { StrategyBlock } from './StrategyBlock';
import { FeaturesBlock } from './FeaturesBlock';
import { GraphSpreads } from './GraphSpreads';

export const PairSpreadItem2: React.FC<IPairExtended> = (pairData: IPairExtended) => {
    const ExpandMore = styled((props: any) => {
        const { expand, ...other } = props;
            return <IconButton {...other} />;
        })(({ theme, expand }) => ({
            transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
            marginLeft: 'auto',
            marginTop: 0,
            transition: theme.transitions.create('transform', {
                duration: theme.transitions.duration.shortest,
            }),
    }));

    return (
        <Card sx={{ width: "100%", maxWidth: "400pt", margin: "0 auto", marginBottom: "5px" }}>
            <CardHeader
                title={`${pairData.base.shortName}`}
                subheader={`${pairData.base.market}, обновлено ${getTimeLeft(pairData.operTime)} назад`}
            />

            <CardContent>
                <div className='container'>
                    { `Базовый ${pairData.base.code}` }
                    {<span className='price'>{`${pairData.base.price?.ask.toFixed(pairData.base.decimals)} руб.`}</span>}
                </div>
            </CardContent>

            { pairData.iisDenied &&
                <Typography variant="body2" color="text.secondary">
                    <div className='infoCaption'>
                        { `⚠️ Запрещено на ИИС` }
                    </div>
                </Typography>
            }

            <StrategyBlock { ...pairData } />

            <FeaturesBlock { ...pairData }  />

            <PairSpreadCalc2 base={ pairData.base } futures={[pairData.futNear, pairData.futFar]} initDepositAmount={ 250000 } />

            <GraphSpreads futNear={ pairData.futNear } futFar={ pairData.futFar } />
        </Card>
    );
}